import { FunnelStat } from "../../../interface/dashboard.interface";
import { FUNNEL_LEGEND } from "../../../utils";
import DashCard from "./DashCard";
import { fmtCount } from "./format";

const norm = (s: string) => s.toLowerCase().replace(/[^a-z]/g, "");

/** Sign-up funnel, in the same stage order and colours as the Users page tags */
const FunnelCard = ({ data, className }: { data?: FunnelStat[]; className?: string }) => {
  const byStage = new Map((data ?? []).map((d) => [norm(d.stage), Number(d.count) || 0]));
  const rows = FUNNEL_LEGEND.map((s) => ({ ...s, count: byStage.get(norm(s.label)) }));
  const top = rows[0]?.count || Math.max(0, ...rows.map((r) => r.count ?? 0));
  const last = rows[rows.length - 1]?.count;

  return (
    <DashCard
      title="Sign-up funnel"
      subtitle={
        top && last !== undefined
          ? `${((last / top) * 100).toFixed(1)}% of opt-ins become elite members`
          : "From opt-in to elite member"
      }
      empty={!data?.length}
      className={className}
    >
      <ul className="space-y-3">
        {rows.map((r, i) => {
          const width = top && r.count !== undefined ? Math.max((r.count / top) * 100, 1.5) : 0;
          const prev = i > 0 ? rows[i - 1].count : undefined;
          const step = prev && r.count !== undefined ? (r.count / prev) * 100 : undefined;
          return (
            <li key={r.label}>
              <div className="mb-1 flex items-baseline justify-between gap-3 text-sm">
                <span className="flex items-center gap-2 text-honeConnectGray">
                  <span className="h-2 w-2 rounded-full" style={{ background: r.color }} />
                  {r.label}
                </span>
                <span className="flex items-baseline gap-2">
                  {step !== undefined && (
                    <span className="text-[11px] text-hcMuted" title="Conversion from the previous stage">
                      {step.toFixed(0)}% of prev
                    </span>
                  )}
                  <span className="font-semibold text-honeConnectBlack">{fmtCount(r.count)}</span>
                </span>
              </div>
              <div className="h-2 rounded-full bg-hcBg">
                <div
                  className="h-2 rounded-full transition-[width] duration-500"
                  style={{ width: `${width}%`, background: r.color }}
                />
              </div>
            </li>
          );
        })}
      </ul>
    </DashCard>
  );
};

export default FunnelCard;
